import defaultSettings from '@/settings';
var title = defaultSettings.title || 'Vue Element Admin';
export default function getPageTitle(pageTitle) {
  // if (pageTitle) {
  //   return `${pageTitle} - ${title}`
  // }
  return "".concat(title);
}